import { useQuery } from 'react-query';

import { DTRRules } from '../types';

import { getDTRRules } from 'RestAPIs/dtrRules';

export const useGetDTRRulesTableData = () =>
  useQuery<DTRRules>(
    ['DTRRules', 'list'],
    async () =>
      await getDTRRules().then((value) =>
        value.data.sort((a, b) => a.dtrRuleId - b.dtrRuleId)
      )
  );
